export const readOnlyPreview = import.meta.env.DEV && import.meta.env.VITE_READ_ONLY_PREVIEW === "true";

// Explicitly reviewed read-only RPCs used by the dashboard. All others fail closed.
const readRpcs = new Set(["reconcile_summary", "category_month_totals"]);
export function previewRequestAllowed(url: string, method: string) {
  const path = new URL(url).pathname;
  if (path.startsWith("/auth/v1/")) {
    return method === "GET" || (method === "POST" && (/^\/auth\/v1\/(token|logout)$/.test(path) || /^\/auth\/v1\/factors\/[^/]+\/(challenge|verify)$/.test(path)));
  }
  if (path.includes("/rpc/")) return readRpcs.has(path.split("/rpc/")[1]);
  return method === "GET" || method === "HEAD";
}

export const previewFetch: typeof fetch = (input, init) => {
  const url = input instanceof Request ? input.url : String(input);
  const method = (init?.method ?? (input instanceof Request ? input.method : "GET")).toUpperCase();
  if (!previewRequestAllowed(url, method)) {
    return Promise.resolve(new Response(JSON.stringify({ message: "Read-only preview: changes are disabled." }), { status: 403, headers: { "Content-Type": "application/json" } }));
  }
  return fetch(input, init);
};
